import { Result, failure, success } from '../shared'
import { LivedataProvider } from './livedata.provider'
import { LivedataServiceErrorCode, LivedataServerData } from './livedata.types'

export class LivedataService {
  constructor(private provider: LivedataProvider) {}

  public async get(): Promise<Result<LivedataServerData>> {
    try {
      const { data } = await this.provider.get()
      return success(data)
    } catch (error) {
      return failure(LivedataServiceErrorCode.GENERAL)
    }
  }
}
